export default __webpack_public_path__ + "static/chd-logo-34f8a9a41ed1f331080132ebeae83f30.svg";